import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { ApiService } from "app/core/api/api.service";
import { Injectable } from "@angular/core";
import { icalActions } from "../actions/ical.actions";
import { catchError, map, of, switchMap, tap } from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class ICalEffects {

    loadCalendarConfig$ = createEffect(() =>this.actions$.pipe(
        ofType(icalActions.loadCalendarConfig),
        tap(() => console.log('Load Calendar Config Effect triggered')),
        switchMap(() => this.api.getCalendarConfig().pipe(
            map(response => icalActions.loadCalendarConfigSuccess({ response })),
            catchError((error) => of(icalActions.loadCalendarConfigError({ error })))
        ))
    ));

    createCalendarConfig$ = createEffect(() => this.actions$.pipe(
        ofType(icalActions.createCalendarConfig),
        switchMap(() => this.api.postCalendarConfig().pipe(
            map(response => icalActions.createCalendarConfigSuccess({ response })),
            catchError((error) => of(icalActions.createCalendarConfigError({ error })))
        ))
    ));

    deleteCalendarConfig$ = createEffect(() => this.actions$.pipe(
        ofType(icalActions.deleteCalendarConfig),
        switchMap(() => this.api.deleteCalendarConfig().pipe(
            map(() => icalActions.deleteCalendarConfigSuccess()),
            catchError((error) => of(icalActions.deleteCalendarConfigError({ error })))
        ))
    ));

    constructor(
        private actions$: Actions,
        private api: ApiService,
        private store: Store,
    ){}
}